import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cancelReservation } from "../api/reservationApi";
import { reservationKeys } from "../api/reservationKeys";

export const useCancelReservation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelReservation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reservationKeys.list() });
    },
  });
};
